import React, { useState } from "react";
import {
  Segment,
  Grid,
  Header,
  Icon,
  Input,
  Button,
  Form,
  Message,
} from "semantic-ui-react";
import { Formik } from "formik";
import * as Yup from "yup";
import { partNumberStringSchema } from "../../../../../../../validation/partNumberYupSchema";

const partNumberValidationSchema = Yup.object({
  part_number: partNumberStringSchema,
});

const InventoryCard = ({ inventory, onPartNumberEdit }) => {
  const [isPartNumberEditing, setIsPartNumberEditing] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [apiError, setApiError] = useState(null);

  const handlePartNumberSubmit = async (values, { setSubmitting }) => {
    if (values.part_number.trim() === inventory.part_number) {
      setIsPartNumberEditing(false);
      setSubmitting(false);
      return;
    }

    try {
      setApiError(null);
      setIsSubmitting(true);

      // Call the parent's edit handler
      await onPartNumberEdit(inventory.inventory_id, values.part_number);

      setIsPartNumberEditing(false);
    } catch (error) {
      console.error("Error updating part number:", error);
      setApiError(error.message || "Failed to update part number");
    } finally {
      setIsSubmitting(false);
      setSubmitting(false);
    }
  };

  const handleStartPartNumberEditing = () => {
    setApiError(null);
    setIsPartNumberEditing(true);
  };

  const handleCancelPartNumberEdit = () => {
    setApiError(null);
    setIsPartNumberEditing(false);
  };

  return (
    <Segment secondary style={{ marginBottom: "20px", marginTop: "20px" }}>
      <Grid>
        <Grid.Row>
          <Grid.Column width={8}>
            <div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Header as="h3" style={{ margin: 0 }}>
                  {inventory.inventory_title}
                </Header>
                {apiError && (
                  <Message negative size="tiny" style={{ marginTop: "5px" }}>
                    <Icon name="exclamation triangle" />
                    {apiError}
                  </Message>
                )}
              </div>
            </div>
            <p style={{ marginTop: "10px" }}>
              Shelf: {inventory?.inventory_shelf}
            </p>
            <p>Current Inv: {inventory?.inv}</p>
          </Grid.Column>
          <Grid.Column width={8}>
            <Header as="h3">Inventory ID: {inventory?.inventory_id}</Header>
            <p style={{ display: "flex", alignItems: "center" }}>
              Part Number:{" "}
              {isPartNumberEditing ? (
                <Formik
                  initialValues={{ part_number: inventory.part_number }}
                  validationSchema={partNumberValidationSchema}
                  onSubmit={handlePartNumberSubmit}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleSubmit,
                    handleChange,
                    isSubmitting: formikSubmitting,
                  }) => (
                    <Form
                      onSubmit={handleSubmit}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        marginLeft: "10px",
                        flex: 1,
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <Input
                          size="mini"
                          name="part_number"
                          value={values.part_number}
                          onChange={handleChange}
                          error={
                            touched.part_number && errors.part_number
                              ? true
                              : false
                          }
                          disabled={isSubmitting}
                        />
                        {touched.part_number && errors.part_number && (
                          <div
                            style={{
                              color: "red",
                              marginTop: "5px",
                              fontSize: "12px",
                            }}
                          >
                            {errors.part_number}
                          </div>
                        )}
                      </div>
                      <div
                        style={{
                          marginLeft: "8px",
                          display: "flex",
                          gap: "5px",
                        }}
                      >
                        <Button
                          icon
                          type="submit"
                          color="green"
                          size="tiny"
                          disabled={
                            isSubmitting ||
                            formikSubmitting ||
                            (touched.part_number && errors.part_number)
                          }
                          loading={isSubmitting}
                        >
                          <Icon name="check" />
                        </Button>
                        <Button
                          icon
                          type="button"
                          color="red"
                          size="tiny"
                          onClick={handleCancelPartNumberEdit}
                          disabled={isSubmitting}
                        >
                          <Icon name="x" />
                        </Button>
                      </div>
                    </Form>
                  )}
                </Formik>
              ) : (
                <>
                  {inventory?.part_number}
                  <Button
                    icon="edit"
                    size="tiny"
                    style={{
                      marginLeft: "10px",
                      minWidth: "unset",
                      width: "32px",
                      height: "32px",
                      padding: 0,
                    }}
                    onClick={handleStartPartNumberEditing}
                  />
                </>
              )}
            </p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

export default InventoryCard;
